import { render } from "./TrainingSection.vue?vue&type=template&id=ae51e7d6&scoped=true&class=relative"
import script from "./TrainingSection.vue?vue&type=script&lang=js"
export * from "./TrainingSection.vue?vue&type=script&lang=js"

import "./TrainingSection.vue?vue&type=style&index=0&id=ae51e7d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.12_webpack@5.96.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae51e7d6"]])

export default __exports__